import React from 'react';
import { sprintf } from 'sprintf';

type Props = {};

export const DiscordSection: React.FC<Props> = () => {
  return (
    <section className='discord-section container d-flex flex-column'>
      <h1 className='headline headline--medium text-center mb-1 mb-sm-2'>
        {'Stay up to date'}
      </h1>
      <p
        className='standfirst--large text-center mb-2'
        dangerouslySetInnerHTML={{
          __html: sprintf(
              'Our %s members get the NFT announcements first, so join now. Also, subscribe to our newsletter to keep up to date with our new artwork launches and other news.'
            ,
            '<a href="https://discord.gg/2cDMwZzVUm" class="link-border">Discord</a>',
          ),
        }}
      />
      <div className='text-center'>
        <a href='https://discord.gg/2cDMwZzVUm'>
          <svg
            width='56'
            height='43'
            viewBox='0 0 56 43'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M47.06 3.72123C43.555 2.11248 39.795 0.927482 35.865 0.248732C35.7937 0.236232 35.7225 0.268732 35.685 0.333732C35.2012 1.19373 34.6662 2.31498 34.2912 3.19748C30.0637 2.56498 25.8575 2.56498 21.7175 3.19748C21.3425 2.29623 20.7875 1.19373 20.3012 0.333732C20.2637 0.269982 20.1925 0.237482 20.1212 0.248732C16.1925 0.924982 12.4337 2.10998 8.92622 3.72123C8.89622 3.73373 8.86997 3.75623 8.85247 3.78498C1.72247 14.4375 -0.231279 24.8287 0.727471 35.09C0.731221 35.14 0.759971 35.1887 0.798721 35.2187C5.50247 38.6737 10.06 40.7712 14.5325 42.1612C14.6037 42.1825 14.68 42.1575 14.725 42.0975C15.7825 40.6525 16.7262 39.13 17.535 37.5275C17.5825 37.4337 17.5375 37.3225 17.44 37.285C15.9437 36.7175 14.52 36.0262 13.15 35.24C13.0412 35.1762 13.0325 35.0212 13.1325 34.9475C13.4212 34.7312 13.7087 34.5062 13.985 34.28C14.035 34.2387 14.1037 34.23 14.1625 34.2562C23.1637 38.3662 32.9087 38.3662 41.8037 34.2562C41.8625 34.2275 41.9312 34.2362 41.9837 34.2775C42.2587 34.505 42.5475 34.7312 42.8375 34.9475C42.9375 35.0212 42.9312 35.1762 42.8225 35.24C41.4525 36.0412 40.0275 36.7175 38.53 37.2825C38.4325 37.32 38.3887 37.4325 38.4362 37.5275C39.2625 39.1275 40.205 40.65 41.2437 42.095C41.2875 42.1562 41.365 42.1825 41.4362 42.16C45.93 40.77 50.4875 38.6725 55.1912 35.2175C55.2325 35.1875 55.2587 35.1412 55.2625 35.0912C56.4087 23.2275 53.3412 12.9225 47.1312 3.78623C47.1162 3.75623 47.09 3.73373 47.06 3.72123ZM18.8787 28.8412C16.1687 28.8412 13.9362 26.3537 13.9362 23.2975C13.9362 20.2412 16.1262 17.7537 18.8787 17.7537C21.6537 17.7537 23.865 20.2637 23.8212 23.2975C23.8225 26.3525 21.6325 28.8412 18.8787 28.8412ZM37.155 28.8412C34.445 28.8412 32.2125 26.3537 32.2125 23.2975C32.2125 20.2412 34.4025 17.7537 37.155 17.7537C39.93 17.7537 42.1412 20.2637 42.0975 23.2975C42.0975 26.3525 39.93 28.8412 37.155 28.8412Z'
              fill='#536DFE'
            />
          </svg>
        </a>
      </div>
    </section>
  );
};
